<ng-template #leftPanel>
    <div
        class="contentGrid input-grid-gaps w-full"
        [class.contentGrid-splitter]="useSplitter()"
    >
        @if (!folder()) {
            <app-work-detail-select-service
                (selectedService)="form.patchValue({ serviceId: $event })"
                [preselected]="form.value.serviceId || this.store.globalGlobalStore.loggedUserStore.selectedServiceId()"
                [workType]="WorkTypeEnum.CONTINUOUS_RECORD"
                [allowedTypes]="[ServiceTypeEnum.SOCIAL]"
            ></app-work-detail-select-service>

            <app-select-person
                #selectPersonComponent
                [form]="form"
                [serviceId]="form.value.serviceId || 0"
                id="personId"
            ></app-select-person>

            <app-select-user
                [form]="form"
                id="userId"
                [label]="'database.persons.continuousRecord.fields.userId'"
                [serviceId]="form.value.serviceId || null"
            ></app-select-user>

            @if (!useSplitter()) {
                <div class="fr-2">&nbsp;</div>
            }
        }

        <app-date-input id="dateFrom" [form]="form" [showTime]="true"></app-date-input>
        <app-select-input
            [form]="form"
            id="form"
            [prefix]="'database.persons.continuousRecord.'"
            [staticOptions]="allowedForms()"
        ></app-select-input>

        <app-tags-input
            #tagsInput
            [class]="!useSplitter() ? 'fr-3' : 'fr-1'"
            [showClear]="true"
            [form]="form"
            [prefix]="'database.persons.continuousRecord.'"
            id="tags"
            [suggestions]="store.data.searchWorkTags()"
            (queryEvent)="queryTags($event)"
        ></app-tags-input>

        <app-social-service-select-offer
            #selectOffers
            [class]="!useSplitter() ? 'fr-4' : 'fr-2'"
            [form]="form"
            [folderId]="folderId()"
            [serviceId]="form.value.serviceId"
            [allowedTypes]="[SocialServiceOperationEnum.BILL, SocialServiceOperationEnum.INFORMATIVE]"
            [enableNoRecordOffers]="false"
        ></app-social-service-select-offer>

        <app-select-input
            #selectPresence
            [form]="form"
            id="presence"
            [staticOptions]="presenceOptions()"
            [prefix]="'database.persons.continuousRecord.'"
        ></app-select-input>

        <app-service-pattern-wysiwyg
            [class]="!useSplitter() ? 'fr-5' : 'fr-3'"
            placeholder="database.persons.continuousRecord.text"
            [form]="form"
            id="data"
            editorKey="WorkContinuousRecordData"
            [height]="undefined"
            [personId]="form.value.personId"
            [serviceId]="form.value.serviceId"
            [usage]="ServicePatternStructureUsageEnum.CONTINUOUS_RECORD"
            (addedPattern)="formAddText(form, 'data', $event.content)"
            [patternGroups]="wysiwygPatterGroupsFolder"
        ></app-service-pattern-wysiwyg>

        @if (!folder()) {
            <app-action-buttons
                [class]="!useSplitter() ? 'fr-5' : 'fr-3'"
                (primaryClickEvent)="save()"
                [primaryButtonLoading]="store.loadingAny()"
                (secondaryClickEvent)="close()"
            ></app-action-buttons>
        }
    </div>
</ng-template>

<ng-template #rightPanel>
    <div class="displayGrid p-3 w-full">
        <app-button
            class="fr-first justify-self-end"
            icon="pi-times"
            [outlined]="true"
            (clickEvent)="useSplitter.set(false)"
        ></app-button>
        <div class="flex align-items-start fr-first">
            @if (existingWork) {
                <app-card-content
                    [work]="$any(existingWork)"
                    [inSplitter]="true"
                    (copyTextToForm)="form.patchValue({ data: $event })"
                ></app-card-content>
            }
        </div>
    </div>
</ng-template>

@if (useSplitter()) {
    <app-splitter
        [fullHeight]="true"
        [panelSizes]="[60, 40]"
    >
        <ng-template #panel>
            <ng-container *ngTemplateOutlet="leftPanel"></ng-container>
        </ng-template>
        <ng-template #panel>
            <ng-container *ngTemplateOutlet="rightPanel"></ng-container>
        </ng-template>
    </app-splitter>
} @else {
    <app-splitter
        [fullHeight]="true"
    >
        <ng-template #panel>
            <ng-container *ngTemplateOutlet="leftPanel"></ng-container>
        </ng-template>
    </app-splitter>
}
